import RevxFlexLayout from 'components/RevxFlexLayout';
import { JobAdjustmentViewer } from 'domains/workspaceDomain';
import { Checkbox } from 'antd';
import NameBadge from 'features/Workspace/components/NameBadge';
import React from 'react';
import { useUser, useRole } from 'hooks';
import { useMount } from 'ahooks';

type Props = {
  data: JobAdjustmentViewer;
  showCheckbox?: boolean;
  callback?: (k: number[]) => void;
};

const JobAdjustmentContact = ({
  data: { supplierContacts },
  showCheckbox = true,
  callback,
}: Props) => {
  const user = useUser();
  const { sourcerRole, supplierRole } = useRole();
  const uId = user?.userId || 0;
  const selectedSupplierContacts = supplierContacts
    .filter((i) => i.selected)
    .map((i) => i.userId);
  const defaultSelectSupplier = [...selectedSupplierContacts, uId];

  useMount(() => {
    callback?.(defaultSelectSupplier);
  });
  return (
    <div className="contact">
      {!!supplierContacts.length && (
        <>
          <RevxFlexLayout
            className="title-bar"
            justify="space-between"
            align="center"
          >
            <div className="title-bar__name">
              <span>{sourcerRole ? 'Supplier contact(s)' : 'Contact(s)'}</span>
            </div>
          </RevxFlexLayout>
          <Checkbox.Group
            defaultValue={defaultSelectSupplier}
            onChange={(v) => {
              callback?.(v.map((i) => +i));
            }}
          >
            <RevxFlexLayout className="name-list mt-20 mb-20" wrap="wrap">
              {supplierContacts.map(
                ({ userId, selected, firstName, lastName }, index) => {
                  if (sourcerRole && !selected) {
                    return <div key={index} />;
                  }
                  const n = firstName + ' ' + lastName;
                  return (
                    <RevxFlexLayout
                      className="name-list__item mr-20 mb-10"
                      key={index}
                    >
                      {userId && supplierRole && showCheckbox && (
                        <Checkbox disabled={uId === userId} value={userId} />
                      )}
                      <div>
                        <NameBadge name={n} />
                      </div>
                      <div>{n}</div>
                    </RevxFlexLayout>
                  );
                }
              )}
            </RevxFlexLayout>
          </Checkbox.Group>
        </>
      )}
    </div>
  );
};

export default JobAdjustmentContact;
